import ResourceGroups from './ResourceGroups';
export default ResourceGroups;
